import { ResponsiveSize } from '~constants';
import { useMediaQuery } from '~hooks';
import { ProductCategoryInformationDesktop, ProductCategoryInformationMobile } from '~templates';
import { Maybe, ProductCategoryAdditionalInfo } from '~types/appsync.types';

interface ProductCategoryInformationProps {
  title?: string;
  additionalInfo?: Maybe<ProductCategoryAdditionalInfo>;
  isLoading?: boolean;
}

const ProductCategoryInformation = ({
  title,
  additionalInfo,
  isLoading = false,
}: ProductCategoryInformationProps) => {
  const isMobile = useMediaQuery(ResponsiveSize.SCREEN_S_MOBILE);

  return isMobile ? (
    <ProductCategoryInformationMobile
      title={title}
      additionalInfo={additionalInfo}
      isLoading={isLoading}
    />
  ) : (
    <ProductCategoryInformationDesktop
      title={title}
      additionalInfo={additionalInfo}
      isLoading={isLoading}
    />
  );
};

export default ProductCategoryInformation;
